export default [
    {
        path: '/project',
        name: 'project',
        component: () => import('@/views/menu/project/project.vue'),
        meta: {
            pageTitle: 'مدیریت پروژه ها',
            action: 'show',
            resource: 'ProjectManager',
        },
    },
    {
        path: '/project/details',
        name: 'addproject',
        component: () => import('@/views/menu/project/projectdetails.vue'),
        meta: {
            pageTitle: 'ایجاد پروژه',
            action: 'show',
            resource: 'ProjectManager',
        },
    },
    {
        path: '/project/details/:id',
        name: 'updateproject',
        component: () => import('@/views/menu/project/projectdetails.vue'),
        meta: {
            pageTitle: 'ویرایش پروژه',
            action: 'show',
            resource: 'ProjectManager',
        },
    },
    {
        path: '/projectcategory',
        name: 'projectcategory',
        component: () => import('@/views/menu/project/projectcategory.vue'),
        meta: {
            pageTitle: 'مدیریت دسته بندی های پروژه',
            action: 'show',
            resource: 'ProjectCategoryManager',
        },
    },
    {
        path: '/projectcategory/details',
        name: 'addprojectcategory',
        component: () => import('@/views/menu/project/projectcategorydetails.vue'),
        meta: {
            pageTitle: 'ایجاد دسته بندی پروژه',
            action: 'show',
            resource: 'ProjectCategoryManager',
        },
    },
    {
        path: '/projectcategory/details/:id',
        name: 'updateprojectcategory',
        component: () => import('@/views/menu/project/projectcategorydetails.vue'),
        meta: {
            pageTitle: 'ویرایش دسته بندی پروژه',
            action: 'show',
            resource: 'ProjectCategoryManager',
        },
    },
]
